import styled, { css } from "styled-components";

const DivContainer = styled.div`
  height: ${(props) => (props && props.divStyle && props.divStyle.height) || "100vh"};
  background: ${(props) => (props && props.divStyle && props.divStyle.background) || "none"};
  align-items: center;
  justify-content: center;
  margin-top: ${(props) => (props && props.divStyle && props.divStyle.marginTop) || "none"};
  padding-top: ${(props) => (props && props.divStyle && props.divStyle.paddingTop) || "none"};
`;

const FormDivContainer = styled.div`
  width: 80vw;
  margin: auto;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  padding-top: 10px;
  font-size: 0.8rem !important;
  max-width: 1400px;
`;

const FormListDivContainer = styled.div`
  /* display: flex; */
  /* flex-direction: column; */
  justify-content: center;
  width: 95%;
  padding-top: 64px;
  left: 2.5%;
  top: 10%;
  align-items: center;
  background-color: #e5e5e5;
  position: relative;
  ${(props) =>
    props.customStyle &&
    css`
      background-color: #ffffff;
      padding-top: 4px;
      width: 100%;
      top: 10%;
      left: 0%;
    `}
`;
export { DivContainer, FormDivContainer, FormListDivContainer };
